import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  label_1: string
  label_2: string | number
  sub_header: boolean | null
}

const Row = ({ label_1, label_2, sub_header }: Props) => {
  return (
    <Table.Row>
      <Table.Cell key={1}>
        <Box textAlign="left" justifyContent="center">
          {sub_header && (
            <Text.Normal size="200" htmlTag="p">
              {label_1}
            </Text.Normal>
          )}
          {!sub_header && (
            <Text.Normal color="grey800" weight="semibold" htmlTag="p" whiteSpace="breakSpaces">
              {label_1}
            </Text.Normal>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell key={2}>
        <Box textAlign="right" justifyContent="center">
          {sub_header && (
            <Text.Normal size="200" htmlTag="p">
              {label_2}
            </Text.Normal>
          )}
          {!sub_header && (
            <Text.Normal color="grey800" weight="semibold" htmlTag="p" whiteSpace="breakSpaces">
              {label_2}x
            </Text.Normal>
          )}
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}

export default observer(Row)
